/**
 * Parsed JSON from Photo ID OCR (api/v1/ai/ocr) using PHOTO_ID_OCR_PROMPT.
 */
export interface PhotoIdOcrResult {
  Summary?: string;
  PatientName?: string;
  DOB?: string;
  DOS?: string;
  Gender?: string;
  Address?: string;
  City?: string;
  State?: string;
  ZipCode?: string;
}

export const PHOTO_ID_OCR_PROMPT = `
You are a JSON API. You only return raw JSON. No markdown. No formatting. No explanations.

Please summarize the document without including the patient's name, age, or gender in the summary. Provide only the results and findings, rephrased in your own words. Avoid using labels such as "Results:" and exclude phrases like "Not Interpreted" or "Not Examined."

Return the summary along with the following extracted fields:
- PatientName
- DOB (must remain exactly as in the document, e.g., "MM-DD-YYYY")
- DOS (must remain exactly as in the document, e.g., "MM-DD-YYYY")
- Gender
- Address
- City
- State
- ZipCode

Requirements:
- The summary must be concise, clear, and well-structured.
- Do NOT change date formats.
- Do NOT infer missing data. If a field is not present, return it as an empty string "".

Output format (example):

{
  "Summary": "Rephrased summary of the patient's medical details.",
  "PatientName": "John Doe",
  "DOB": "MM-DD-YYYY",
  "DOS": "MM-DD-YYYY",
  "Gender": "Male",
  "Address": "",
  "City": "",
  "State": "",
  "ZipCode": ""
}

Output rules (STRICT — DO NOT VIOLATE):
- Return ONLY a valid JSON object.
- The response MUST start with "{" and end with "}".
- Do NOT include \`\`\`json, \`\`\` or any markdown formatting.
- Do NOT include any extra text, explanation, labels, or wrappers.
- Do NOT include keys like "role", "parts", or any outer structure.
- Use only double quotes for JSON.
- The response must be directly parseable using JSON.parse() without modification.

If you include anything other than raw JSON, the response is INVALID.
`.trim();
